import { FriendListItemCoreProps } from "../types"
import React from "react"
import { StyleSheet } from "~/ui/primitives"
import { observer } from "mobx-react-lite"
import { Avatar } from "~widgets/avatar"
import { Name, Username } from "~components/text"
import styled from '~/ui/styled'
import { FriendStatus } from "~proto"
import { CenterFlex, ColumnFlex, StartFlex } from "~components/El"

const SmallText = styled.Text`
  font-size: 14px;
  color: #ababab;
`

const Row = styled(ColumnFlex)`
  align-items: center;
  flex-direction: row;
  width: auto;
`

const UserInfo = ({ name, atUsername }) => (
  <Row>
   <CenterFlex mr='10px' mb='4px' >{name}</CenterFlex>
    <Username atUsername={atUsername} />
  </Row>
)

const Container = styled(ColumnFlex)`
  flex: 1;
  flex-direction: row;
  align-items: center;
  padding: ${({ theme }) => theme.space.sm};
`

const Main = styled(ColumnFlex)`
  flex: 1;
  width: 100%;
  padding: 10px 0;
  margin-left: 10px;
`

const MoreBtn = styled.Pressable`
  padding: 7px 10px;
  border-radius: 6px;
  background-color: ${(p) => p.theme.colors.primary};
  align-self: flex-start;
`

const MoreBtnText = styled.Text`
  color: #fff;
  font-size: 14px;
`
const RejBtn = styled.Pressable`
  margin-left: 6px;
  padding: 7px 10px;
  border-radius: 6px;
  background-color: ${(p) => p.theme.colors.background};
`

const RejBtnText = styled.Text`
  color: ${({ theme }) => theme.colors.secondaryText};
  font-size: 14px;
`
export const FriendListItemCore: React.FC<FriendListItemCoreProps> = ({ friend, onAccept, onReject }) => {
  return (
    <Container>
      <Avatar avatar={friend.user.avatar} name={friend.user.name} />
      <Main>
        <UserInfo name={friend.user.name} atUsername={friend.user.username} />
        {friend.status === FriendStatus.PENDING && (
          <StartFlex>
          <MoreBtn onClick={onAccept}>
            <MoreBtnText>接受</MoreBtnText>
          </MoreBtn>
          <RejBtn onClick={onReject}>
            <RejBtnText>拒绝</RejBtnText>
          </RejBtn>
          </StartFlex>
        )}
        {friend.status === FriendStatus.APPROVED && <SmallText>已接受</SmallText>}
      </Main>
    </Container>
  )
}

export default observer(FriendListItemCore)
